import { render, staticRenderFns } from "./AccreditationItem.vue?vue&type=template&id=b108daae&"
import script from "./AccreditationItem.vue?vue&type=script&lang=js&"
export * from "./AccreditationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports